import { render, staticRenderFns } from "./DocumentValuesDialog.vue?vue&type=template&id=346c2e70&scoped=true"
import script from "./DocumentValuesDialog.vue?vue&type=script&lang=js"
export * from "./DocumentValuesDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentValuesDialog.vue?vue&type=style&index=0&id=346c2e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346c2e70",
  null
  
)

export default component.exports